import React from 'react';

function ActiveStatus({checked, onStatusChange, name}) {
    return (
        <>
            <div className="card-header py-3 d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
                <h6 className="m-0 fw-bold">Active Status</h6>
            </div>
            <div className="card-body">
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name={name}
                        onChange={onStatusChange}
                        checked={checked === "1"}
                        value="1"
                    />
                    <label className="form-check-label">
                        Active
                    </label>
                </div>
                <div className="form-check">
                    <input
                        onChange={onStatusChange}
                        className="form-check-input"
                        type="radio"
                        name={name}
                        checked={checked === "0"}
                        value="0"
                    />
                    <label className="form-check-label">
                        Inactive
                    </label>
                </div>
            </div>
        </>
    )
}
export default ActiveStatus;